import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpService } from './http.service';

export interface TasadorCoin {
  id: string;
  name: string;
  shortname: string;
}

export interface FeeDisplay {
  percentage_fee: number;
  fixed_fee: number;
  fixed_fee_currency: string | null;
}

export interface TasadorQuoteResult {
  fee_id?: string | number | null;
  source_currency: string;
  target_currency: string;
  rate: number;
  fee: number;
  amount_send: number | null;
  amount_net?: number | null;
  recipient_gets: number | null;
  client_fee?: number;
  total_origin?: number | null;
  user_fee?: number;
  user_flat_fee?: number;
  service_provider?: string | null;
  provider_service_id?: string | number | null;
  provider_id?: string | number | null;
  spot_provider?: string | null;
  rate_source?: string | null;
  rate_via?: string | null;
  provider_quote_id?: string | number | null;
  provider_quote_ttl_seconds?: number | null;
  provider_quote_created_at?: string | number | null;
  provider_quote_expires_at?: string | number | null;
  provider_quote?: any;
  consulted_rate_id?: string | number | null;
  consulted_rate_expiration?: string | null;
  consulted_rate_expires_in_seconds?: number | null;
  consulted_rate_status?: string | null;
  consulted_rate_metadata?: any;
  quote_options?: TasadorQuoteResult[];
  /** Tarifa on-ramp (envío) para la moneda origen */
  fee_on_ramp?: FeeDisplay | null;
  /** Tarifa off-ramp (recepción) para la moneda destino */
  fee_off_ramp?: FeeDisplay | null;
}

export interface CreateExchangeFromQuotePayload {
  consulted_rate_id: string | number;
}

@Injectable()
export class TasadorService {
  constructor(private http: HttpService) {}

  getCoins(): Promise<{ data: TasadorCoin[] }> {
    return new Promise((resolve, reject) => {
      this.http.get('tasador/coins').subscribe(
        (resp: any) => {
          if (resp?.status === 'Success' && Array.isArray(resp?.data)) {
            resolve({ data: resp.data });
          } else {
            reject(resp?.message || 'Error al cargar monedas');
          }
        },
        (err) => reject(err?.message || err)
      );
    });
  }

  getPairs(): Promise<{ data: { source: string; target: string }[] }> {
    return new Promise((resolve, reject) => {
      this.http.get('tasador/pairs').subscribe(
        (resp: any) => {
          if (resp?.status === 'Success' && Array.isArray(resp?.data)) {
            resolve({ data: resp.data });
          } else {
            reject(resp?.message || 'Error al cargar pares');
          }
        },
        (err) => reject(err?.message || err)
      );
    });
  }

  getQuote(params: {
    source_currency: string;
    target_currency: string;
    amount_send?: number | null;
    fee_in_source?: number | null;
  }): Promise<{ data: TasadorQuoteResult }> {
    const body: any = {
      source_currency: params.source_currency,
      target_currency: params.target_currency,
    };
    if (params.amount_send != null && params.amount_send > 0) {
      body.amount_send = params.amount_send;
    }
    if (params.fee_in_source != null && params.fee_in_source > 0) {
      body.fee_in_source = params.fee_in_source;
    }
    return new Promise((resolve, reject) => {
      this.http.post('tasador/quote', body).subscribe(
        (resp: any) => {
          if (resp?.status === 'Success' && resp?.data) {
            resolve({ data: resp.data });
          } else {
            reject(resp?.message || 'Error al obtener cotización');
          }
        },
        (err) => reject(err)
      );
    });
  }

  createExchangeFromQuote(body: CreateExchangeFromQuotePayload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post('tasador/exchange', body).subscribe(
        (resp: any) => {
          if (resp?.status === 'Success') {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        (err) => reject(err),
      );
    });
  }
}
